import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const fmt = (n) =>
    "₹ " + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtInt = (n) =>
    "₹ " + Math.round(Number(n || 0)).toLocaleString("en-IN");

export const fmtNum = (n) =>
    Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// "Rupees Seventeen Thousand Six Hundred Fifty Only"
const _INDIAN_ONES = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten",
    "Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
const _INDIAN_TENS = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];

function _twoDigit(n) {
    if (n < 20) return _INDIAN_ONES[n];
    const t = Math.floor(n / 10), r = n % 10;
    return _INDIAN_TENS[t] + (r ? " " + _INDIAN_ONES[r] : "");
}
function _threeDigit(n) {
    const h = Math.floor(n / 100), r = n % 100;
    const parts = [];
    if (h) parts.push(_INDIAN_ONES[h] + " Hundred");
    if (r) parts.push(_twoDigit(r));
    return parts.join(" ");
}
export function amountInWords(v) {
    let n = Math.round(Number(v || 0));
    if (n === 0) return "Rupees Zero Only";
    const parts = [];
    const crore = Math.floor(n / 10000000); n %= 10000000;
    const lakh  = Math.floor(n / 100000);   n %= 100000;
    const thou  = Math.floor(n / 1000);     n %= 1000;
    if (crore) parts.push(_twoDigit(crore) + " Crore");
    if (lakh)  parts.push(_twoDigit(lakh)  + " Lakh");
    if (thou)  parts.push(_twoDigit(thou)  + " Thousand");
    if (n)     parts.push(_threeDigit(n));
    return "Rupees " + parts.join(" ") + " Only";
}

export default api;
